import React, { useState } from 'react'
import Image from 'gatsby-image/withIEPolyfill'
import styled from 'styled-components'
import { mediaQuery } from 'utils/style'
import ExpandIcon from './ExpandIcon'

const Img = styled(({ className, children, style }) => (
  <div className={className} children={children} style={style} />
))`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;
  ${({ flex, row, col }) =>
    (flex ? `flex:1 0 auto;${col ? 'max-width:100%; width: auto;' : 'max-height:100%; height: auto;'}` : '')}
  ${props =>
    (props.relative
      ? `
    max-width:100%;
    max-height:100%;
  `
      : '')}
  :hover {
    ${({ hover }) => hover || ''}
  }
  ${mediaQuery()}

  img ,
  > .gatsby-image-wrapper {
    ${({ absolute }) =>
    (absolute
      ? `position: absolute !important;
        top: 0;
        left: 0;`
      : '')}
    width: 100%;
    height: 100%;
    ${props =>
    props.relative
      && `
      max-width:100%;
      max-height:100%;
    `}
    object-fit: contain !important;
    ${props => props.imageStyle}
  }
`
const BGImg = styled.div`
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  height: 100%;
  ${mediaQuery()}

  img,
  > .gatsby-image-wrapper {
    object-fit: cover;
    width: 100%;
    height: 100%;
    ${props => props.imageStyle}
  }
`

const Fullscreen = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: black;
  z-index: 99999;
  img,
  > .gatsby-image-wrapper {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
`

const Expand = styled.div`
  position: absolute;
  left: 64px;
  top: 64px;
  height: 40px;
  width: 40px;
  padding: 10px;
  background: rgba(0, 0, 0, 0.2);
`

export default function SBImage ({
  src,
  background,
  children,
  alt,
  title,
  description,
  objectPosition,
  fallback,
  expandable,
  critical,
  ...props
}) {
  const [expanded, setExpanded] = useState(false)
  const Wrapper = background ? BGImg : Img

  return (
    <>
      {expanded && (
      <Fullscreen onClick={() => setExpanded(false)}>
        {expandable?.localFile ? (
        expandable.localFile.childImageSharp ? (
          <Image
            {...expandable.localFile.childImageSharp}
            alt={alt}
            title={title}
            description={description}
            objectFit="contain"
            objectPosition={objectPosition}
          />
        ) : (
          <img
            src={expandable.localFile.publicURL}
            alt={alt}
            title={title}
            description={description}
            objectFit="contain"
          />
        )
      ) : (
        typeof expandable === 'string'
        && expandable && (
          // && (fallback ? (
          //   <FallbackImage
          //     key={src}
          //     src={src}
          //     fallback={fallback}
          //     alt={alt}
          //     title={title}
          //     description={description}
          //     background={background}
          //     objectPosition={objectPosition}
          //   />
          // ) : (
          <img
            src={expandable}
            alt={alt}
            title={title}
            description={description}
            objectFit="contain"
            objectPosition={objectPosition}
          />
        )
      )}
      </Fullscreen>
      )}
      <Wrapper {...props}>
        {src?.localFile ? (
        src.localFile.childImageSharp ? (
          <Image
            {...src.localFile.childImageSharp}
            alt={alt}
            title={title}
            description={description}
            objectFit={background ? 'cover' : 'contain'}
            objectPosition={objectPosition}
            critical={critical}
            fadeIn={!critical}
          />
        ) : (
          <img
            src={src.localFile.publicURL}
            alt={alt}
            title={title}
            description={description}
            objectFit={background ? 'cover' : 'contain'}
          />
        )
      ) : (
        typeof src === 'string'
        && src && (
          // && (fallback ? (
          //   <FallbackImage
          //     key={src}
          //     src={src}
          //     fallback={fallback}
          //     alt={alt}
          //     title={title}
          //     description={description}
          //     background={background}
          //     objectPosition={objectPosition}
          //   />
          // ) : (
          <img
            src={src}
            alt={alt}
            title={title}
            description={description}
            objectFit={background ? 'cover' : 'contain'}
            objectPosition={objectPosition}
          />
        )
      )}
        {expandable && !expanded && <Expand onClick={() => setExpanded(true)}><ExpandIcon /></Expand>}
        {children}
      </Wrapper>
    </>
  )
}
